import * as React from 'react'
import Logo from './logo'
import Button from '../Default'
import { makeStyles } from '@material-ui/core/styles'

export default function Index({ children, ...props }) {
  const s = useStyle({})

  return (
    <Button className={s.button} {...props}>
      <Logo className={s.logo} />
      {children}
    </Button>
  )
}

const useStyle = makeStyles({
  button: {
    fontWeight: 600,
    color: '#FFF',
    backgroundColor: '#000',
    borderRadius: 25,
    '&:hover': {
      backgroundColor: '#000',
    },
    '&:disabled': {
      backgroundColor: '#000',
      color: '#fff',
    },
  },
  logo: {
    position: 'absolute',
    left: 20,
    height: '100%',
  },
})
